import React from 'react';
import {
    Document,
    Page,
    Text,
    Image,
    View,
    StyleSheet,
} from '@react-pdf/renderer';



const PDFcomponent = props => {
    const { PDFImageIds } = props;

    const IdsArray = [];
    let count = 0;

    const styles = StyleSheet.create({
        page: {
            backgroundColor: 'white',
            marginTop: '1.27cm',
            marginBottom: '1.09cm',

        },
        body: {
            width: "8.5 in",
            margin: "0 in .1875 in",
            backgroundColor: 'white',
            display: 'block'
        },
        view: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            width: '50%',
        },
        div: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            width: '50%',
        },
        QRImage: {
            width: '70%',
            height: '65%',
            margin: "auto"
        },
        text: {
            color: '#0081C6',
            size: '0.5rem',
            margin: "auto"
        },
        pageBreak: {
            clear: "left",
            display: "block",
            pageBreakAfter: "always"
        }

    });

    //const resultArray = PDFImageIds.map(id => {
    //    IdsArray.push(id.BARITEMID);
    //    return document.getElementById(id.BARITEMID).toDataURL();
    //});

    return (
        <Document>

            {PDFImageIds.map((dataURL, idx) => {
                if (idx % 24 == 0) {
                    return (
                        <Page key={"PageId"} size={'LETTER'} style={styles.page}>

                            {PDFImageIds.map((dataURL, id) => {
                                
                                if (id >= idx && id < idx + 24 && id % 3 == 0) {
                                    let im = "";
                                    if (id < PDFImageIds.length) {
                                        //CPW-159 QR scan is returning incorrect results - change back to be the item - Deepthi N H
                                        im = "https://api.qrserver.com/v1/create-qr-code/?data=" + PDFImageIds[id].INV_ITEM_ID + "&amp;size=30x40"
                                    }
                                    
                                    let im1 = "";
                                    if (id + 1 < PDFImageIds.length) {
                                        //CPW-159 QR scan is returning incorrect results - change back to be the item - Deepthi N H
                                        im1 = "https://api.qrserver.com/v1/create-qr-code/?data=" + PDFImageIds[id + 1].INV_ITEM_ID + "&amp;size=30x40"
                                    }
                                    let im2 = "";
                                    if (id + 2 < PDFImageIds.length) {
                                        //CPW-159 QR scan is returning incorrect results - change back to be the item - Deepthi N H
                                        im2 = "https://api.qrserver.com/v1/create-qr-code/?data=" + PDFImageIds[id + 2].INV_ITEM_ID + "&amp;size=30x40"
                                    }

                                    return (
                                        <View style={{ "display": "flex", "flexDirection": "row", "justifyContent": "space-evenly", "flexWrap": "wrap", "height": "11%", "marginTop": "1px", "marginRight": "5px" }} key={id}>
                                            {id % 3 == 0 && id <= PDFImageIds.length - 1 ? <div style={{
                                                "display": "flex", "flexDirection": "row", "width": "32%"

                                            }}>
                                                <div style={{ "display": "flex", "flexDirection": "column", "width": "70%", "margin": "auto" }}>
                                                    <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id].INV_ITEM_ID}</Text>
                                                    <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id].BINLOCATION}</Text>
                                                    <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id].DESCR}</Text>
                                                    <div style={{ "display": "flex", "flexDirection": "row", "flexWrap": "wrap", "marginLeft": "10%" }}>
                                                        <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id].MFG_ID}, </Text>
                                                        <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id].MFG_ITM_ID}</Text>
                                                    </div>
                                                </div>
                                                <div style={{ "width": "30%", "float": "right" }}>
                                                    <Image allowDangerousPaths src={im} alt="" title="" style={styles.QRImage} />
                                                </div>
                                            </div> : <div style={{
                                                "display": "flex", "flexDirection": "row", "width": "32%"
                                            }}></div>
                                            }

                                            {(id + 1) % 3 == 1 && id + 1 < PDFImageIds.length ?
                                                <div style={{
                                                    "display": "flex", "flexDirection": "row", "width": "32%"
                                                }}>

                                                    <div style={{ "display": "flex", "flexDirection": "column", "width": "70%", "margin": "auto" }}>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 1].INV_ITEM_ID}</Text>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 1].BINLOCATION}</Text>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 1].DESCR}</Text>
                                                        <div style={{ "display": "flex", "flexDirection": "row", "flexWrap": "wrap", "marginLeft": "10%" }}>
                                                            <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id + 1].MFG_ID}</Text>
                                                            <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id + 1].MFG_ITM_ID}</Text>
                                                        </div>
                                                    </div>
                                                    <div style={{ "width": "30%", "float": "right" }}>
                                                        <Image allowDangerousPaths src={im1} alt="" title="" style={styles.QRImage} />
                                                    </div>
                                                </div> : <div style={{
                                                    "display": "flex", "flexDirection": "row", "width": "32%"
                                                }}></div>}
                                            {id + 2 < PDFImageIds.length && (id + 2) % 3 == 2 ?
                                                <div style={{
                                                    "display": "flex", "flexDirection": "row", "width": "32%"
                                                }}>
                                                    <div style={{ "display": "flex", "flexDirection": "column", "width": "70%", "margin": "auto" }}>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 2].INV_ITEM_ID}</Text>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 2].BINLOCATION}</Text>
                                                        <Text style={{ "fontSize": "9px", "marginLeft": "10%" }}>{PDFImageIds[id + 2].DESCR}</Text>
                                                        <div style={{ "display": "flex", "flexDirection": "row", "flexWrap": "wrap", "marginLeft": "10%" }}>
                                                            <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id + 2].MFG_ID}</Text>
                                                            <Text style={{ "fontSize": "9px" }}>{PDFImageIds[id + 2].MFG_ITM_ID}</Text>
                                                        </div>
                                                    </div>
                                                    <div style={{ "width": "30%", "float": "right" }}>
                                                        <Image allowDangerousPaths src={im2} alt="" title="" style={styles.QRImage} />
                                                    </div>
                                                </div> : <div style={{
                                                    "display": "flex", "flexDirection": "row", "width": "32%"
                                                }}></div>}

                                        </View>
                                    )
                                }
                            })}

                        </Page>
                    )
                }
            })}
        </Document>
    );
};

export default PDFcomponent;